
import Vue from "vue";
import { HorizontalBar } from "vue-chartjs";

export default Vue.extend({
    extends: HorizontalBar,
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    x: { stacked: true },
                    y: { stacked: true },
                    xAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                        },
                    ],
                },
            },
        };
    },
    props: {
        datasets: Array,
        labels: Array,
    },
    computed: {
        chartdata() {
            return {
                labels: this.labels,
                datasets: this.datasets,
            };
        },
    },
    mounted() {
        this.renderChart(this.chartdata, this.options);
    },
});
